import React from 'react';
import Loader from 'components/common/Loader';

const ButtonLoader = ({ isSubmitting, color }) => (
  <>{isSubmitting && <Loader color={color ? color : '#fff'} />}</>
);

export default ButtonLoader;
